module.exports = __webpack_public_path__ + "img/logo@2x.8775ddc3.png";